import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllProjects, deleteProject } from "../../services/projectsService";
import { useAuth } from '../../context/AuthContext';
import '../../css/all-projects.css';
import { toast } from 'react-toastify'; // if you're using toast notifications

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { profileId } = useAuth();
  const [activeMenuId, setActiveMenuId] = useState(null);

  const handleEdit = (project) => {
    navigate('/home/projects/create', { state: { projectToEdit: project } });
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this project?");
    if (!confirmDelete) return;

    try {
      // Delete the project via the service
      await deleteProject(id);

      // Update the project list after deletion
      setProjects((prevProjects) => prevProjects.filter((project) => project.id !== id));

      toast.success("Project deleted successfully!");
    } catch (error) {
      toast.error("Failed to delete project. Please try again.");
      console.error("Delete error:", error);
    }
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const data = await getAllProjects();
        setProjects(data);
      } catch (error) {
        console.error("Failed to load projects:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  const handleProjectClick = (id) => {
    navigate(`/home/projects/${id}`);
  };

  if (loading) {
    return (
      <div className='profile-spinner-container'>
        <div className='centered-content'>
          <div className="profile-spinner-wrapper">
            <div className="profile-spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="all-projects-main">
      <div className="projects-header">
        <h2><i className="fa-solid fa-folder"></i> Projects</h2>
        <button className="add-project-button" onClick={() => navigate('/home/projects/create')}>
          <i className="fa-solid fa-plus"></i> New Project
        </button>
      </div>

      {projects.length === 0 ? (
        <p>No Projects.</p>
      ) : (
        <>
          <p className="projects-length">{projects.length} result{projects.length !== 1 && 's'}</p>
          <div className="project-folders">
            {projects.map((project) => (
              <div
                key={project.id}
                className="project-folder"
                onClick={() => handleProjectClick(project.id)}
              >
                <div
                  className="folder-thumb"
                >
                  {project.images?.[0]?.image_500x500 && (
                    <img
                      src={project.images[0].image_500x500}
                      alt=""
                      className="folder-image"
                    />
                  )}
                  <div className="top-right-controls">
                    {profileId === project.profile_id && (
                      <div className="ellipsis-dropdown">
                        <button className="ellipsis-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            setActiveMenuId(activeMenuId === project.id ? null : project.id);
                          }}>
                          <i className="fa-solid fa-ellipsis-vertical"></i>
                        </button>
                        {activeMenuId === project.id && (
                          <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
                            <button className='dropdown-menu-item' onClick={() => handleEdit(project)}><i className="fa-solid fa-pencil icon-space"></i> Edit</button>
                            <button className='dropdown-menu-item' onClick={() => handleDelete(project.id)}><i className="fa-solid fa-trash trash-icon icon-space"></i> Delete</button>
                          </div>
                        )}
                      </div>
                    )}

                  </div>
                </div>
                <h3 className="project-folder-title">{project.title}</h3>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Projects;
